import { create } from 'zustand'

import type { RealtimeStatus } from '@/services/contracts'

interface RealtimeState {
  status: RealtimeStatus
  lastEventAt: string | null
  setStatus: (status: RealtimeStatus) => void
  recordEvent: (occurredAt: string) => void
}

/** Bağlantı durumu — sunucu verisi değil, ulaşım katmanının kendi durumu. */
export const useRealtimeStore = create<RealtimeState>()((set) => ({
  status: 'connecting',
  lastEventAt: null,
  setStatus: (status) => {
    set({ status })
  },
  recordEvent: (occurredAt) => {
    set({ lastEventAt: occurredAt })
  },
}))
